import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { AdminLayout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Plus, Pencil } from "lucide-react";

export default function AdminActivityTypes() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [open, setOpen] = useState(false);

  const load = () => api.get("/activity-types", { params: { active_only: false } }).then(r => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      const payload = { name: editing.name, active: editing.active !== false };
      if (editing.id) await api.patch(`/admin/activity-types/${editing.id}`, payload);
      else await api.post("/admin/activity-types", payload);
      toast.success("Sparat"); setOpen(false); load();
    } catch (e) { toast.error(e.response?.data?.detail || "Fel"); }
  };

  return (
    <AdminLayout title="Aktivitetstyper" actions={
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild><Button data-testid="at-new" onClick={() => setEditing({ name: "", active: true })} className="bg-[#E1251B] hover:bg-[#C81D14] rounded-full"><Plus size={16} className="mr-1"/>Ny typ</Button></DialogTrigger>
        <DialogContent>
          <DialogHeader><DialogTitle>{editing?.id ? "Redigera" : "Ny"} aktivitetstyp</DialogTitle></DialogHeader>
          {editing && (<div className="space-y-3">
            <div><Label>Namn</Label><Input data-testid="at-name" value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })}/></div>
            <div className="flex items-center justify-between"><Label>Aktiv</Label><Switch checked={editing.active !== false} onCheckedChange={v => setEditing({ ...editing, active: v })}/></div>
          </div>)}
          <DialogFooter><Button data-testid="at-save" onClick={save} className="bg-[#E1251B] hover:bg-[#C81D14]">Spara</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    }>
      <div className="bg-white border border-slate-200 rounded-2xl overflow-hidden">
        <Table>
          <TableHeader><TableRow><TableHead>Namn</TableHead><TableHead>Status</TableHead><TableHead></TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map(o => (
              <TableRow key={o.id} data-testid={`at-item-${o.name}`}>
                <TableCell className="font-medium">{o.name}</TableCell>
                <TableCell><span className={`text-xs px-2 py-0.5 rounded-full ${o.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-100 text-slate-500"}`}>{o.active ? "Aktiv" : "Inaktiv"}</span></TableCell>
                <TableCell className="text-right"><Button size="sm" variant="ghost" onClick={() => { setEditing(o); setOpen(true); }}><Pencil size={14}/></Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </AdminLayout>
  );
}
